<!-- ----------------------------------------------- -->
<template>
  <v-card class="com-pc-card tm-pc-obs-list-card" obs-list-type="other">
    <v-row class="com-pc-card-header">
      <span class="com-pc-card-title">{{ text.title }}</span>
    </v-row>
    <template v-if="!isEmpty(rpTmList) || !isEmpty(scamList)">
      <v-col class="com-pc-card-contents py-1">
        <!-- 通常水位 -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in rpTmList.nmStg"
          :key="`stg-${subItem.obsCd}`"
        >
          <v-list-item
            @click="clickObsList(subItem.ofcCd, 4, subItem.obsCd)"
            class="py-0"
          >
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(4, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title class="tm-nm"
                >{{ getObsNm(subItem) }}
                <v-chip
                  v-show="showOvlvlLabel(subItem.stgOvlvl)"
                  class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                  :rw-info-color="setRwInfoColor(subItem.stgOvlvl)"
                  label
                  x-small
                  >{{ getStgOvlvlNm(subItem.stgOvlvl) }}</v-chip
                >
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-row no-gutters v-if="stgMode == 1 && subItem.dspFlg == 1">
                  <v-col v-if="subItem.obsTime != null" class="col-4 tm-date">{{
                    getDispDate(4, subItem)
                  }}</v-col>
                  <v-col v-else class="col-4"></v-col>
                  <v-col class="col-4 tm-rvr-item">{{
                    subItem.items[1].desc
                  }}</v-col>
                  <v-col v-if="subItem.stgCcd == 190" class="col tm-rvr-item">{{
                    text.missing
                  }}</v-col>
                  <v-col
                    v-else-if="subItem.stgCcd == 140"
                    class="col tm-rvr-item"
                    >{{ text.closing }}</v-col
                  >
                  <v-col
                    v-else-if="
                      subItem.items[1].val != null &&
                        subItem.obsTime != null &&
                        subItem.stgCcd < 130 &&
                        subItem.stgCcd != null
                    "
                    class="col tm-rvr-item"
                    >{{ subItem.items[1].val
                    }}{{ subItem.items[1].unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ text.noData }}{{ subItem.items[1].unit }}</v-col
                  >
                  <v-col class="tm-rvr-item">
                    <v-icon
                      v-if="subItem.stgCcd >= 130 || subItem.obsTime == null"
                    ></v-icon>
                    <v-icon
                      v-else-if="subItem.stg10mChgCcd >= 130"
                    ></v-icon>
                    <v-icon
                      v-else-if="subItem.stg10mChg < 0"
                      class="icon-arrow-down"
                      >arrow_downward</v-icon
                    >
                    <v-icon
                      v-else-if="subItem.stg10mChg === 0"
                      class="icon-arrow-down"
                      >arrow_forward</v-icon
                    >
                    <v-icon
                      v-else-if="subItem.stg10mChg > 0"
                      class="icon-arrow-up"
                      >arrow_upward</v-icon
                    >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="
                            subItem.stgCcd >= 130 || subItem.obsTime == null
                          "
                        ></v-icon>
                        <v-icon
                          v-else-if="
                            subItem.items[1].stgQmflg != null &&
                              subItem.items[1].stgQmflg != '0'
                          "
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <v-row no-gutters v-else>
                  <v-col v-if="subItem.obsTime != null" class="col-4 tm-date">{{
                    getDispDate(4, subItem)
                  }}</v-col>
                  <v-col v-else class="col-4"></v-col>
                  <v-col class="col-4 tm-rvr-item">{{
                    subItem.items[0].desc
                  }}</v-col>
                  <v-col v-if="subItem.stgCcd == 190" class="col tm-rvr-item">{{
                    text.missing
                  }}</v-col>
                  <v-col
                    v-else-if="subItem.stgCcd == 140"
                    class="col tm-rvr-item"
                    >{{ text.closing }}</v-col
                  >
                  <v-col
                    v-else-if="
                      subItem.items[0].val != null &&
                        subItem.obsTime != null &&
                        subItem.stgCcd < 130 &&
                        subItem.stgCcd != null
                    "
                    class="col tm-rvr-item"
                    >{{ subItem.items[0].val
                    }}{{ subItem.items[0].unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ text.noData }}{{ subItem.items[0].unit }}</v-col
                  >
                  <v-col class="tm-rvr-item">
                    <v-icon
                      v-if="subItem.stgCcd >= 130 || subItem.obsTime == null"
                    ></v-icon>
                    <v-icon
                      v-else-if="subItem.stg10mChgCcd >= 130"
                    ></v-icon>
                    <v-icon
                      v-else-if="subItem.stg10mChg < 0"
                      class="icon-arrow-down"
                      >arrow_downward</v-icon
                    >
                    <v-icon
                      v-else-if="subItem.stg10mChg === 0"
                      class="icon-arrow-down"
                      >arrow_forward</v-icon
                    >
                    <v-icon
                      v-else-if="subItem.stg10mChg > 0"
                      class="icon-arrow-up"
                      >arrow_upward</v-icon
                    >
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="
                            subItem.stgCcd >= 130 || subItem.obsTime == null
                          "
                        ></v-icon>
                        <v-icon
                          v-else-if="
                            subItem.items[0].stgQmflg != null &&
                              subItem.items[0].stgQmflg != '0'
                          "
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- 危機管理水位 -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in rpTmList.nmSwstg"
          :key="`swstg-${subItem.swobsCd}`"
        >
          <v-list-item
            @click="clickSwObsList(subItem.swofcCd, 300, subItem.swobsCd)"
            class="py-0"
          >
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(300, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title class="tm-nm">
                {{ subItem.swobsNm }}
                <v-chip
                  v-show="showOvlvlLabel(subItem.swstgOvlvl)"
                  class="tm-pc-stg-ovlvl-color ml-1 mb-1"
                  :rw-info-color="setRwInfoColor(subItem.swstgOvlvl)"
                  label
                  x-small
                  >{{ getSwStgOvlvlNm(subItem.swstgOvlvl) }}</v-chip
                >
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-row no-gutters>
                  <v-col v-if="subItem.obsTime != null" class="col-4 tm-date">{{
                    getDispDate(300, subItem)
                  }}</v-col>
                  <v-col v-else class="col-4"></v-col>
                  <v-col class="col-4 tm-rvr-item">{{
                    subItem.items[0].desc
                  }}</v-col>
                  <v-col
                    v-if="subItem.swstgCcd == 190"
                    class="col tm-rvr-item"
                    >{{ text.missing }}</v-col
                  >
                  <v-col
                    v-else-if="subItem.swstgCcd == 140"
                    class="col tm-rvr-item"
                    >{{ text.closing }}</v-col
                  >
                  <v-col
                    v-else-if="
                      subItem.items[0].val != null &&
                        subItem.obsTime != null &&
                        subItem.swstgCcd != null &&
                        subItem.swstgCcd < 130
                    "
                    class="col tm-rvr-item"
                    >{{ subItem.items[0].val
                    }}{{ subItem.items[0].unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ text.noData }}{{ subItem.items[0].unit }}</v-col
                  >
                  <v-col class="tm-rvr-item">
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-icon
                          v-if="
                            subItem.items[0].stgQmFlg != null &&
                              subItem.items[0].stgQmFlg != 0
                          "
                          v-on="on"
                          class="icon-qmflg"
                          >warning</v-icon
                        >
                        <v-icon v-else></v-icon>
                      </template>
                      <span>{{ text.abnormal }}</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- 河川カメラ-->
        <v-list
          class="rp-tm-list"
          v-for="subItem in scamList"
          :key="`cctv-${subItem.scamId}`"
        >
          <v-list-item
            @click="
              clickCctvList(
                100,
                subItem.scamId,
                subItem.ownCd,
                subItem.sysCamId
              )
            "
            v-if="subItem.sysId === 2 || subItem.sysId === 3"
          >
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(100, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title
                class="tm-nm"
                v-text="subItem.name"
              ></v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- 簡易カメラ -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in scamList"
          :key="`scam-${subItem.scamId}`"
        >
          <v-list-item
            @click="
              clickScamList(
                200,
                subItem.scamId,
                subItem.ownCd,
                subItem.sysCamId
              )
            "
            v-if="subItem.sysId === 1"
          >
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(200, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title
                class="tm-nm"
                v-text="subItem.name"
              ></v-list-item-title>
              <v-list-item-subtitle></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- ダム諸量 -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in rpTmList.nmDam"
          :key="`dam-${subItem.obsCd}`"
        >
          <v-list-item @click="clickObsList(subItem.ofcCd, 7, subItem.obsCd)">
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(7, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title
                class="tm-nm"
                v-text="subItem.obsNm"
              ></v-list-item-title>
              <v-list-item-subtitle>
                <v-row
                  no-gutters
                  v-for="(data, tmDamIdx) in subItem.items"
                  :key="`tmDamIdx-${tmDamIdx}`"
                >
                  <v-col
                    v-if="tmDamIdx === 0 && subItem.obsTime != null"
                    class="col-4 tm-date"
                    >{{ getDispDate(7, subItem) }}</v-col
                  >
                  <v-col v-else class="col-4"></v-col>
                  <v-col v-if="tmDamIdx === 0" class="col tm-rvr-item">{{
                    data.desc
                  }}</v-col>
                  <v-col v-else class="col-4 tm-rvr-item">
                    <span>{{ data.desc }}</span>
                  </v-col>
                  <v-col v-if="data.ccd == 190" class="col tm-rvr-item">{{
                    text.missing
                  }}</v-col>
                  <v-col v-else-if="data.ccd == 140" class="col tm-rvr-item">{{
                    text.closing
                  }}</v-col>
                  <v-col
                    v-else-if="
                      data.ccd == null || data.ccd > 130 || data.val == null
                    "
                    class="col tm-rvr-item"
                    >{{ text.noData }}{{ data.unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ data.val }}{{ data.unit }}</v-col
                  >
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- 雨量 -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in rpTmList.nmRain"
          :key="`rn-${subItem.obsCd}`"
        >
          <v-list-item @click="clickObsList(subItem.ofcCd, 1, subItem.obsCd)">
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(1, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title
                class="tm-nm"
                v-text="subItem.obsNm"
              ></v-list-item-title>
              <v-list-item-subtitle>
                <v-row
                  no-gutters
                  v-for="(data, tmRnIdx) in subItem.items"
                  :key="`tmRnIdx-${tmRnIdx}`"
                >
                  <v-col
                    v-if="tmRnIdx === 0 && subItem.obsTime != null"
                    class="col-4 tm-date"
                    >{{ getDispDate(1, subItem) }}</v-col
                  >
                  <v-col v-else class="col-4"></v-col>
                  <v-col v-if="tmRnIdx === 0" class="col tm-rvr-item">{{
                    data.desc
                  }}</v-col>
                  <v-col v-else class="col-4 tm-rvr-item">
                    <span>{{ data.desc }}</span>
                  </v-col>
                  <v-col v-if="data.ccd == 190" class="col tm-rvr-item">{{
                    text.missing
                  }}</v-col>
                  <v-col v-else-if="data.ccd == 140" class="col tm-rvr-item">{{
                    text.closing
                  }}</v-col>
                  <v-col
                    v-else-if="
                      data.ccd == null ||
                        data.ccd > 130 ||
                        data.val == null ||
                        subItem.obsTime == null
                    "
                    class="col tm-rvr-item"
                    >{{ text.noData }}{{ data.unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ data.val }}{{ data.unit }}</v-col
                  >
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- 海岸 -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in rpTmList.nmCoast"
          :key="`coast-${subItem.obsCd}`"
        >
          <v-list-item @click="clickObsList(subItem.ofcCd, 12, subItem.obsCd)">
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(12, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title
                class="tm-nm"
                v-text="subItem.obsNm"
              ></v-list-item-title>
              <v-list-item-subtitle>
                <v-row
                  no-gutters
                  v-for="(data, tmCtIdx) in subItem.items"
                  :key="`tmCtIdx-${tmCtIdx}`"
                >
                  <v-col
                    v-if="tmCtIdx === 0 && subItem.obsTime != null"
                    class="col-4 tm-date"
                    >{{ getDispDate(12, subItem) }}</v-col
                  >
                  <v-col v-else class="col-4"></v-col>
                  <v-col v-if="tmCtIdx === 0" class="col tm-rvr-item">{{
                    data.desc
                  }}</v-col>
                  <v-col v-else class="col-4 tm-rvr-item">
                    <span>{{ data.desc }}</span>
                  </v-col>
                  <v-col v-if="data.ccd == 190" class="col tm-rvr-item">{{
                    text.missing
                  }}</v-col>
                  <v-col v-else-if="data.ccd == 140" class="col tm-rvr-item">{{
                    text.closing
                  }}</v-col>
                  <v-col
                    v-else-if="
                      data.ccd == null || data.ccd > 130 || data.val == null
                    "
                    class="col tm-rvr-item"
                    >{{ text.noData }}{{ data.unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ data.val }}{{ data.unit }}</v-col
                  >
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- 積雪深 -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in rpTmList.nmSnow"
          :key="`snw-${subItem.obsCd}`"
        >
          <v-list-item @click="clickObsList(subItem.ofcCd, 3, subItem.obsCd)">
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(3, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title
                class="tm-nm"
                v-text="subItem.obsNm"
              ></v-list-item-title>
              <v-list-item-subtitle>
                <v-row
                  no-gutters
                  v-for="(data, tmSwIdx) in subItem.items"
                  :key="`tmSwIdx-${tmSwIdx}`"
                >
                  <v-col
                    v-if="tmSwIdx === 0 && subItem.obsTime != null"
                    class="col-4 tm-date"
                    >{{ getDispDate(3, subItem) }}</v-col
                  >
                  <v-col v-else class="col-4"></v-col>
                  <v-col v-if="tmSwIdx === 0" class="col tm-rvr-item">{{
                    data.desc
                  }}</v-col>
                  <v-col v-else class="col-4 tm-rvr-item">
                    <span>{{ data.desc }}</span>
                  </v-col>
                  <v-col v-if="data.ccd == 190" class="col tm-rvr-item">{{
                    text.missing
                  }}</v-col>
                  <v-col v-else-if="data.ccd == 140" class="col tm-rvr-item">{{
                    text.closing
                  }}</v-col>
                  <v-col
                    v-else-if="
                      data.ccd == null || data.ccd > 130 || data.val == null
                    "
                    class="col tm-rvr-item"
                    >{{ text.noData }}{{ data.unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ data.val }}{{ data.unit }}</v-col
                  >
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <!-- 水質 -->
        <v-list
          class="rp-tm-list"
          v-for="subItem in rpTmList.nmTmQwtr"
          :key="`qwtr-${subItem.obsCd}`"
        >
          <v-list-item @click="clickObsList(subItem.ofcCd, 6, subItem.obsCd)">
            <v-list-item-action>
              <img class="tm-list-icon-size" :src="getIcon(6, subItem)" />
            </v-list-item-action>
            <v-list-item-content class="tm-pc-list-content-inf">
              <v-list-item-title
                class="tm-nm"
                v-text="subItem.obsNm"
              ></v-list-item-title>
              <v-list-item-subtitle>
                <v-row
                  no-gutters
                  v-for="(data, tmWtIdx) in subItem.items"
                  :key="`tmWtIdx-${tmWtIdx}`"
                >
                  <v-col
                    v-if="tmWtIdx === 0 && subItem.obsTime != null"
                    class="col-4 tm-date"
                    >{{ getDispDate(6, subItem) }}</v-col
                  >
                  <v-col v-else class="col-4"></v-col>
                  <v-col v-if="tmWtIdx === 0" class="col tm-rvr-item">{{
                    data.desc
                  }}</v-col>
                  <v-col v-else class="col-4 tm-rvr-item">
                    <span>{{ data.desc }}</span>
                  </v-col>
                  <v-col v-if="data.ccd == 190" class="col tm-rvr-item">{{
                    text.missing
                  }}</v-col>
                  <v-col v-else-if="data.ccd == 140" class="col tm-rvr-item">{{
                    text.closing
                  }}</v-col>
                  <v-col
                    v-else-if="
                      data.ccd == null || data.ccd > 130 || data.val == null
                    "
                    class="col tm-rvr-item"
                    >{{ text.noData }}{{ data.unit }}</v-col
                  >
                  <v-col v-else class="col tm-rvr-item"
                    >{{ data.val }}{{ data.unit }}</v-col
                  >
                </v-row>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </template>
    <template v-else>
      <v-col class="tm-no-regist">{{
        this.$store.state.app.config.messageConfig.rpNoRegist
      }}</v-col>
    </template>
  </v-card>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用登録地点情報画面 登録観測所一覧カード
 * RpTmList.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import WebStorage from "../../lib/webStorage.js";
import util from "./../../lib/util.js";
import TmList from "./../../lib/tmList.js";

export default {
  name: "rp-tm-list",
  mixins: [mixin],
  data() {
    return {
      tmDatas: { scamPoint: [], swPoint: [], tmPoint: [] },
      /** 文字列リソース */
      text: {
        noData: "--",
        title: "登録観測所一覧",
        missing: "欠測",
        closing: "閉局",
        abnormal: "異常のおそれあり",
      },
    };
  },
  /** マウント後イベント */
  mounted() {
    this.$log.debug("[rp/TmList]mut - getRpTmListDatas()");
    this.tmDatas = WebStorage.getPointInfo(this.point).tmDatas;
    this.getRpTmListDatas();
  },
  props: {
    point: { type: Number, default: 0 },
  },
  computed: {
    /**取得時間パラメータ */
    tmPointDatasParam: {
      get() {
        return this.$store.state.Telemeter.tmPointIndivDatasParam;
      },
    },
    scamList: {
      get() {
        return this.tmDatas.scamPoint;
      },
    },
    /**
     * 観測日時(ファイル取得用)
     */
    appTimeRound: {
      get() {
        return this.$store.state.app.appTimeRound;
      },
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          appTime: this.$store.state.app.appTime,
          // tmDatas: WebStorage.getPointInfo(this.point).tmDatas,
          tmDatas: this.tmDatas,
          // 観測日時 [true:最新, false:履歴]
          isCurrent: this.$store.state.app.isCurrent,
        };
      },
    },
    /**
     * 登録地点の観測所一覧を取得
     */
    rpTmList: {
      get() {
        return this.$store.state.Telemeter.tmPointIndivDatas;
      },
    },
    /**
     * 水位表示モードの取得
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /**
     * 水防団モードの取得
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /** 登録地点読み込み日時 */
    editWebStorageDate: {
      get() {
        return this.$store.state.map.editWebStorageDate;
      },
    },
    /** 浸水情報一覧を取得 */
    luList() {
      return this.luList;
    },
  },
  methods: {
    /** 登録地点の観測所一覧を取得 */
    getRpTmListDatas() {
      this.$log.debug("[rp/TmList] getTmPointIndivData()");
      setTimeout(() => {
        this.$store.dispatch("Telemeter/getTmPointIndivData", {
          appTime: this.reqParam.appTime,
          appTimeRound: this.appTimeRound,
          tmObj: this.reqParam.tmDatas,
        });
      }, 500);
    },
    /** 個別観測所画面へ遷移 */
    clickObsList(ofcCd, itmkndCd, obsCd) {
      this.$log.debug(
        "[rp/TmList] clickObsList(" + ofcCd + "," + itmkndCd + "," + obsCd + ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: ofcCd,
        itmkndCd: itmkndCd,
        obsCd: obsCd,
      });
      // 画面遷移
      this.routerPushTm("/pc/tm");
    },
    /** 危機管理観水位測所画面へ遷移 */
    clickSwObsList(swofcCd, itmkndCd, swobsCd) {
      this.$log.debug(
        "[rp/TmList] clickSwObsList(" +
          swofcCd +
          "," +
          itmkndCd +
          "," +
          swobsCd +
          ")"
      );
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParam", {
        ofcCd: null,
        itmkndCd: 300,
        obsCd: null,
      });
      this.$store.commit("Swin/setSelectedSwParam", {
        swofcCd: swofcCd,
        itmkndCd: itmkndCd,
        swobsCd: swobsCd,
      });
      // 画面遷移
      this.routerPushTmSw("/pc/tm");
    },
    /** CCTV画面へ遷移 */
    clickCctvList(itmkndCd, scamId, ownCd, sysCamId) {
      this.$log.debug(
        "[rp/TmList] clickCctvList(" +
          itmkndCd +
          "," +
          scamId +
          "," +
          ownCd +
          "," +
          sysCamId +
          ")"
      );
      // パネル拡大モードOFF
      this.$store.commit("app/setPcPanelMode", false);
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParamScam", {
        itmkndCd: itmkndCd,
        scamId: scamId,
        ownCd: ownCd,
        sysCamId: sysCamId,
      });
      // 画面遷移
      this.routerPushTmScam("/pc/tm");
    },
    /** 簡易カメラ画面へ遷移 */
    clickScamList(itmkndCd, scamId, ownCd, sysCamId) {
      this.$log.debug(
        "[rp/TmList] clickScamList(" +
          itmkndCd +
          "," +
          scamId +
          "," +
          ownCd +
          "," +
          sysCamId +
          ")"
      );
      // パネル拡大モードOFF
      this.$store.commit("app/setPcPanelMode", false);
      // 選択中テレメータ情報を設定
      this.$store.commit("Telemeter/setSelectedTmParamScam", {
        itmkndCd: itmkndCd,
        scamId: scamId,
        ownCd: ownCd,
        sysCamId: sysCamId,
      });
      // 画面遷移
      this.routerPushTmScam("/pc/tm");
    },
    /**
     * 日付を表示フォーマットに変換
     */
    getDispDate(itmkndCd, obsItem) {
      this.$log.debug("[rp/TmList] getDispDate(" + obsItem.obsTime + ")");
      if (TmList.checkNotCollected(itmkndCd, obsItem)) {
        // 未収集
        return this.text.noData;
      }
      return util.formatDate24(obsItem.obsTime, "YYYY/MM/DD HH:mm");
    },
    /**
     * リストは空かどうかの判定
     */
    isEmpty(obsList) {
      this.$log.debug("[rp/TmList] isEmpty(" + obsList + ")");
      if (obsList == null) {
        return true;
      } else if (Object.keys(obsList).length == 0) {
        return true;
      } else {
        for (let type in obsList) {
          if (obsList[type].length !== 0) {
            return false;
          }
        }
        return true;
      }
    },
    /**
     * 観測所アイコンの取得
     */
    getIcon(tm, item) {
      this.$log.debug("[rp/TmList] getIcon(" + tm + item + this.isFldCtl + ")");
      return TmList.getIcon(tm, item, this.isFldCtl);
    },
    /**
     * 超過観測所 着色
     */
    setRwInfoColor(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "occurrence";
      } else if (stgOvlvl === 80 || stgOvlvl === 70) {
        return "danger";
      } else if (stgOvlvl === 60 || stgOvlvl === 50) {
        return "refuge";
      } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
        return "warn";
      }
      return "other";
    },
    /**
     * 超過基準水位名を表示するか
     */
    showOvlvlLabel(stgOvlvl) {
      if (30 <= stgOvlvl && stgOvlvl <= 90) {
        return true;
      }
      return false;
    },
    /**
     * 通常水位：超過基準水位名の取得
     */
    getStgOvlvlNm(stgOvlvl) {
      return TmList.getStgOvlvlNm(stgOvlvl);
    },
    /**
     * 危機管理水位：超過基準水位名の取得
     */
    getSwStgOvlvlNm(stgOvlvl) {
      return TmList.getSwStgOvlvlNm(stgOvlvl);
    },
    /**
     * 観測所名の取得
     */
    getObsNm(item) {
      if (
        item.fldfrFlg === 1 ||
        item.evstgFlg === 1 ||
        (this.isFldCtl && item.fldctlFlg === 1)
      ) {
        // 洪水予報観測所フラグ、もしくは水位周知基準観測所フラグが有効
        // または、水防団モードで、且つ水防警報観測所フラグが有効の時
        return item.obsNm[1];
      }
      return item.obsNm[0];
    },
  },
  watch: {
    appTimeRound() {
      this.$log.debug("[rp/TmList]watch - getRpTmListDatas()");
      this.getRpTmListDatas();
    },
    point() {
      this.$log.debug("[rp/TmList]watch - getRpTmListDatas()");
      this.tmDatas = WebStorage.getPointInfo(this.point).tmDatas;
      this.getRpTmListDatas();
    },
    // webストレージ編集日時更新を監視
    editWebStorageDate() {
      this.$log.debug("[rp/TmList]watch - getRpTmListDatas()");
      this.tmDatas = WebStorage.getPointInfo(this.point).tmDatas;
      this.getRpTmListDatas();
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.tm-no-regist {
  font-size: middle;
}
.rp-tm-list {
  padding-top: 0px;
  padding-bottom: 0px;
}
</style>
